import { createI18n } from 'vue-i18n'
import storage from '@/plugins/storage'
import { localeOptions } from '@/constants/locale/config'
import en from '@/constants/locale/en'
import ja from '@/constants/locale/ja'

const langaugeMap = lang => (
  !lang ? 'en' :
  !lang.includes('ja') ? 'ja' :
  'en'
)

const getLocale = () => {
  let locale = storage.get('locale')
  return localeOptions.some(option => option.value === locale) ? locale : langaugeMap(window.navigator.language || navigator.userLanguage)
}

export default createI18n({
  locale: getLocale(),
  fallbackLocale: 'en',
  warnHtmlInMessage: 'off',
  messages: { en, ja }
})